import React, { useEffect, useRef, useState, useMemo } from "react";
import { Select, Checkbox, Tooltip, Spin, Empty } from "antd";
import { cloneDeep, get, map } from "lodash";

// import IconChevron from "@assets/icon_chevron.svg";
import "./multiSelect.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import classNames from "classnames";

const { Option } = Select;

const OptionVal = ({ option, handleChange, selectedValues, disabled }: any) => {
  const optionRef = useRef(null);

  const [showTooltip, setShowTooltip] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    console.log("OptionVal.useEffect");
    if (get(optionRef, "current.clientWidth", 0) < get(optionRef, "current.scrollWidth", 0)) {
      setShowTooltip(true);
    }
  });

  return showTooltip ? (
    <Tooltip title={option.title}>
      <div ref={optionRef} className="custom-multiSelect__checkbox">
        <Checkbox disabled={disabled} value={option.value} onChange={(e) => handleChange({ source: "checkbox", e })} checked={selectedValues.includes(option.value)} />
        <span>{option.label || option.title}</span>
      </div>
    </Tooltip>
  ) : (
    <div ref={optionRef} className="custom-multiSelect__checkbox">
      <Checkbox disabled={disabled} value={option.value} onChange={(e) => handleChange({ source: "checkbox", e })} checked={selectedValues.includes(option.value)} />
      <span>{option.label || option.title}</span>
    </div>
  );

  //  return <><Checkbox value={option.value} onChange={(e) => handleChange({source : "checkbox" , e})} checked={selectedValues.includes(option.value)}/><span>{option.title}</span></>
};

const MultiSelect = (props: { className?: string; handleSelect: (arg0: any) => void; value: any; options: any; disabled?: boolean; loadingOptions?: boolean; placeholder?: string }) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [selectedValues, setselectedValues] = useState<string[]>([]);
  useEffect(() => {
    console.log("MultiSelect.useEffect");
    if (props.value?.split(":").length > 0) {
      setselectedValues(props.value?.split("$|"));
    } else if (!props.value) {
      setselectedValues([]);
    }
  }, [props.value]);

  const dropdownOptions = useMemo(() => {
    const selectedOptionValues = props.value?.split("$|");
    let temp_dropdownOptions = cloneDeep(props.options);
    let selectedOptions: any[] = [];
    let unselectedOptions: any[] = [];
    if (temp_dropdownOptions.length > 0) {
      temp_dropdownOptions.forEach((dropdownOption: any) => {
        if (selectedOptionValues?.indexOf(dropdownOption.value) === -1) {
          unselectedOptions.push(dropdownOption);
        } else {
          selectedOptions.push(dropdownOption);
        }
      });
      return [...selectedOptions, ...unselectedOptions];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.options, dropdownOpen]);

  const handleChange = ({ source, e }: any) => {
    console.log("MultiSelect.handleChange");
    let updatedSelectedValues: string[] = [];
    if (source === "checkbox") {
      if (e.target.checked && !selectedValues.includes(e.target.value)) {
        updatedSelectedValues = [...selectedValues, e.target.value];
      } else {
        updatedSelectedValues = selectedValues.filter((val) => val !== e.target.value);
      }
    } else if (source === "dropdown") {
      if (!selectedValues.includes(e)) {
        updatedSelectedValues = [...selectedValues, e];
      } else {
        updatedSelectedValues = selectedValues?.filter((s: string) => s !== e);
      }
    }
    // the below filter is to remove the empty string from the updatedSelectedValues
    updatedSelectedValues = updatedSelectedValues.filter((val) => val.trim() !== "");
    setselectedValues(updatedSelectedValues);
    props.handleSelect(updatedSelectedValues.join("$|"));
  };

  // adding dynamic classnames
  const selectClassName = classNames(props.className, "ui-select", {
    "custom-multi-select-disable-input-text-area": props.disabled,
  });

  return (
    <Tooltip title={props.value?.split("$|").join(", ")}>
      <Select
        className={selectClassName}
        style={{ width: 275 }}
        open={dropdownOpen}
        placeholder={props.placeholder ? props.placeholder : "Select Option"}
        optionFilterProp="children"
        onChange={(option: any) => handleChange({ source: "dropdown", e: option })}
        // Added logic to stop event propagation when it is disabled
        onClick={() => setDropdownOpen(true)}
        onBlur={() => setDropdownOpen(false)}
        value={
          !dropdownOpen
            ? selectedValues.length > 0
              ? `${selectedValues.length > 0 ? selectedValues[0] : ""} 
      ${selectedValues.length > 1 ? "(+" + (selectedValues.length - 1) + ")" : ""}`
              : undefined
            : ""
        }
        // suffixIcon={
        //   <span className="down-arrow">
        //     <img src={IconChevron} alt="chevron-icon" />
        //   </span>
        // }
        showSearch={!props.disabled}
        notFoundContent={props.loadingOptions ? <Spin size="small" indicator={<HealthemSpinner />} /> : <Empty />}
        filterOption={(input, option: any) => {
          return option.value.toLowerCase().includes(input.toLowerCase()) || get(option, "label", "").toLowerCase().includes(input.toLowerCase());
        }}
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {/* <Input/> */}
        {(dropdownOptions || []).length > 0
          ? map(dropdownOptions, (option) => {
              return (
                <Option key={option.value} value={option.value} label={option.label} className="filters-row-option" disabled={props.disabled}>
                  <OptionVal option={option} handleChange={handleChange} selectedValues={selectedValues} disabled={props.disabled} />
                </Option>
              );
            })
          : !props.loadingOptions && (
              <Option key="1" value="" className="filters-row-option">
                {" "}
              </Option>
            )}
      </Select>
    </Tooltip>
  );
};

export default MultiSelect;
